import { mapActions, mapMutations } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'

import SagahHeader from '@/components/header'
import SagahFooter from '@/components/footer'

export default {
  components: {
    SagahHeader,
    SagahFooter
  },
  data () {
    return {
      showPassword: false,
      isLoadingLogin: false,
      username: '',
      password: '',
      apiKey: '6Lc--yYjAAAAAGmSMhD79uSrmjHjOeotd_6FAxzk'
    }
  },
  mounted () {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `https://www.recaptcha.net/recaptcha/api.js?render=${this.apiKey}`)
    document.head.appendChild(recaptchaScript)
  },
  methods: {
    ...mapMutations([
      'SET_ACCOUNT'
    ]),
    ...mapActions([
      'actionAuth'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    login () {
      if (window.grecaptcha) {
        window.grecaptcha.execute(this.apiKey, { action: 'signin' }).then(response => {
          this.isLoadingLogin = true
          const params = {
            username: this.username,
            password: this.password,
            applicationAlias: process.env.VUE_APP_APPLICATION_ALIAS,
            recaptcha: response
          }

          this.actionAuth(params)
            .then((response) => {
              this.isLoadingLogin = false
              if (!response.applications.find(application => (application.alias === process.env.VUE_APP_APPLICATION_ALIAS) && application.roles.find(role => role.alias === 'administrator'))) {
                localStorage.removeItem('access-token')
                this.addToast({
                  text: 'Você não tem permissão para acessar essa aplicação.',
                  type: 'warning'
                })
              } else {
                this.SET_ACCOUNT(response)
                this.$router.push({ name: 'Private' })
              }
            })
            .catch((e) => {
              this.isLoadingLogin = false
              const message = this.getErrorMessage(e.status)

              this.addToast({
                text: message,
                type: 'danger'
              })
            })
        })
      }
    },
    getErrorMessage (status) {
      return {
        401: 'Usuário ou senha inválidos',
        404: 'Usuário não encontrado',
        500: 'Ocorreu um erro inesperado no servidor, por favor tente novamente mais tarde.'
      }[status]
    },
    validateAllFields () {
      if (!this.username || !this.password) {
        return false
      } else {
        this.login()
      }
    }
  }
}
